module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraBold.8d02e14.ttf";